import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import * as f from "../../utils/formatter";
import HandoverAppointmentTemplate from "./HandoverAppointmentTemplate";
import IconNotes from "../icons/IconNotes";

const HandoverAppointments = ({ open, handleClose, appointments }) => {
  const [handoverTemplateDialogId, setHandoverTemplateDialogId] =
    React.useState(null);

  return (
    <div>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Předání</DialogTitle>

        <DialogContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Jméno klienta</TableCell>
                  <TableCell>Typ schůzky</TableCell>
                  <TableCell>Čas vyzvednutí</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {appointments.map((appointment) => (
                  <TableRow key={appointment.id}>
                    <TableCell>
                      <Box display="flex" gap={1}>
                        {f.fullName(appointment.client)}
                        <IconNotes appointment={appointment} />
                      </Box>
                    </TableCell>
                    <TableCell>{appointment.service.name}</TableCell>
                    <TableCell>{f.time24(appointment.start)}</TableCell>
                    <TableCell>
                      {" "}
                      <Button
                        onClick={() =>
                          setHandoverTemplateDialogId({
                            serviceId: appointment.service.id,
                            appointmentId: appointment.id,
                          })
                        }
                        variant="outlined"
                      >
                        Zápis
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "right" }}>
          <Button onClick={handleClose} variant="contained">
            Zavřít
          </Button>
        </DialogActions>
      </Dialog>

      {handoverTemplateDialogId && (
        <HandoverAppointmentTemplate
          onClose={() => setHandoverTemplateDialogId(null)}
          {...handoverTemplateDialogId}
        />
      )}
    </div>
  );
};

export default HandoverAppointments;
